/* =====================================================================
   Incisione personalizzata - 26 AGO 2026

   COSA FA
   Aggiunge sotto lo step 1 (i dispositivi) un pulsante che apre un
   pannello dove il cliente scrive il testo da incidere. Con "The Bond",
   che contiene due inalatori, i campi diventano due.

   DOVE FINISCE IL TESTO
   1) come proprieta di riga sull'inalatore, cosi il testo viaggia
      attaccato all'oggetto da incidere ed e visibile in carrello,
      ordine e bolla di consegna;
   2) come riga a se, il prodotto "Incisione personalizzata", cosi il
      magazzino ha un segnale che non puo sfuggire: se in ordine c'e
      quel prodotto, ci sono incisioni da fare. La quantita e pari al
      numero di incisioni.

   COME SI AGGANCIA AL CARRELLO
   La sezione chiama window.abIncisione.applicaAlCarrello(...) subito
   dopo aver messo l'inalatore nella lista degli articoli: una riga sola
   dentro il file dei dev, tutto il resto vive qui.
   ===================================================================== */
(function () {
  var radice = document.querySelector('[data-ab-incisione]');
  if (!radice) return;

  var MAX = parseInt(radice.dataset.max, 10) || 16;
  var MAIUSCOLO = radice.dataset.maiuscolo === '1';
  var VARIANTE_PRODOTTO = radice.dataset.varianteProdotto || '';
  var NOME_DOPPIO = (radice.dataset.nomeDoppio || 'The Bond').trim().toLowerCase();
  /* 30 AGO 2026: l'aggancio buono e' questo. Il nome resta solo come ripiego
     per il caso in cui l'impostazione non sia mai stata salvata. */
  var VARIANTE_DOPPIA = (radice.dataset.varianteDoppia || '').trim();

  var ETICHETTA_SINGOLA = radice.dataset.etichettaSingola || '';
  var ETICHETTA_RIFERITO = radice.dataset.etichettaRiferito || 'For';
  var PULSAZIONE = radice.dataset.pulsazione === '1';
  var DURATA = Math.max(1600, Math.min(4000, parseInt(radice.dataset.durata, 10) || 2600));

  var apri = radice.querySelector('[data-ab-incisione-apri]');
  var pannello = radice.querySelector('[data-ab-incisione-pannello]');
  var titolo = radice.querySelector('[data-ab-incisione-titolo]');
  var riassunto = radice.querySelector('[data-ab-incisione-riassunto]');
  var conferma = radice.querySelector('[data-ab-incisione-conferma]');
  var togli = radice.querySelector('[data-ab-incisione-togli]');
  var campo2 = radice.querySelector('[data-ab-incisione-campo="2"]');
  var input1 = radice.querySelector('[data-ab-incisione-input="1"]');
  var input2 = radice.querySelector('[data-ab-incisione-input="2"]');
  var conteggio1 = radice.querySelector('[data-ab-incisione-conteggio="1"]');
  var conteggio2 = radice.querySelector('[data-ab-incisione-conteggio="2"]');
  var etichetta1 = radice.querySelector('[data-ab-incisione-etichetta="1"]');
  var etichetta2 = radice.querySelector('[data-ab-incisione-etichetta="2"]');

  /* testi presi dalle etichette gia tradotte, per non duplicare le stringhe */
  var TESTO_AGGIUNGI = titolo ? titolo.textContent.trim() : '';
  var TESTO_MODIFICA = radice.dataset.testoModifica || TESTO_AGGIUNGI;

  var confermato = { uno: '', due: '' };

  /* --------------------------------------------------------------- */

  function ripulisci(valore) {
    var v = (valore || '').replace(/[^A-Za-zÀ-ÿ0-9 ]/g, '');
    v = v.replace(/\s{2,}/g, ' ');
    if (MAIUSCOLO) v = v.toUpperCase();
    return v.slice(0, MAX);
  }

  function dispositivoSelezionato() {
    return document.querySelector('#custom-product .step_one_cls .select-button.selected');
  }

  function elementoVariante() {
    var b = dispositivoSelezionato();
    return b ? b.closest('.variant') : null;
  }

  /* "The Bond" contiene due inalatori: servono due incisioni.

     Si guarda l'ID della variante, non il nome: "The Bond" e' un titolo e si puo'
     tradurre: sul mercato tedesco il nucleo "Menta Fresca" si chiama gia' "Frische
     Minze", e un confronto sul nome li' non e' mai vero. Se l'id non c'e' (impostazione
     mai salvata) si ripiega sul nome, che e' meglio di niente. */
  function eLaDoppia(v) {
    if (!v) return false;
    if (VARIANTE_DOPPIA) return String(v.dataset.variantId || '').trim() === VARIANTE_DOPPIA;
    return (v.dataset.name || '').trim().toLowerCase() === NOME_DOPPIO;
  }

  function serveDoppia() {
    return eLaDoppia(elementoVariante());
  }

  /* I nomi dei due inalatori NON sono scritti a mano: si leggono dallo
     step 1, escludendo la variante doppia. Cosi' se domani cambiano
     nome o lingua, le etichette seguono da sole. */
  function nomiInalatori() {
    var nomi = [];
    document.querySelectorAll('#custom-product .step_one_cls .variant').forEach(function (v) {
      var n = (v.dataset.name || '').trim();
      if (n && !eLaDoppia(v)) nomi.push(n);
    });
    return nomi;
  }

  /* Con The Bond l'etichetta e' la stessa del caso singolo piu' il nome
     dell'inalatore: "Texto a grabar - Amber", "Texto a grabar - Walnut". */
  function etichettaPer(indice) {
    var nomi = nomiInalatori();
    var nome = nomi[indice] || '';
    if (!nome) return ETICHETTA_SINGOLA;
    return ETICHETTA_SINGOLA + ' \u00B7 ' + nome;
  }

  function aggiornaConteggio(input, span) {
    if (!input || !span) return;
    var n = input.value.length;
    span.textContent = n + '/' + MAX;
    span.classList.toggle('is-al-limite', n >= MAX);
  }

  function almenoUnTesto() {
    if (!input1) return false;
    if (input1.value.trim()) return true;
    return serveDoppia() && input2 && !!input2.value.trim();
  }

  function aggiornaStatoPulsanti() {
    if (conferma) conferma.disabled = !almenoUnTesto();
  }

  function mostraCampoDue() {
    var doppia = serveDoppia();
    if (campo2) campo2.hidden = !doppia;
    if (!doppia && input2) { input2.value = ''; aggiornaConteggio(input2, conteggio2); }
    /* con un inalatore solo resta "Texto a grabar"; con The Bond ogni
       campo dice a quale dei due inalatori si riferisce */
    if (etichetta1) etichetta1.textContent = doppia ? etichettaPer(0) : ETICHETTA_SINGOLA;
    if (etichetta2) etichetta2.textContent = etichettaPer(1);
  }

  /* Il respiro dell'etichetta "gratis" non e un evento che scatta una
     volta: e uno stato, ricalcolato da capo a ogni cambiamento.

     Deve respirare quando, e solo quando, il cliente ha scelto
     l'inalatore e non ha (ancora, o piu) messo l'incisione. Quindi:
     la mette e si ferma, la toglie e riprende.

     classList.add su una classe gia presente non fa ripartire
     l'animazione: e per questo che si puo richiamare a ogni cambio di
     colore senza vedere lo scatto del respiro che riparte da capo. */
  function aggiornaRichiamo() {
    if (!PULSAZIONE) return;
    var badge = apri ? apri.querySelector('.ab-incisione__badge') : null;
    if (!badge) return;
    var deve = !!dispositivoSelezionato() && !confermato.uno && !confermato.due;
    if (deve) {
      badge.style.setProperty('--ab-durata', DURATA + 'ms');
      badge.classList.add('is-richiama');
    } else {
      badge.classList.remove('is-richiama');
    }
  }

  function aggiornaPulsante() {
    var attivo = !!(confermato.uno || confermato.due);
    aggiornaRichiamo();
    var doppia = serveDoppia();
    apri.classList.toggle('is-attivo', attivo);
    /* con due incisioni il riepilogo va a destra del titolo, non sotto:
       due righe sotto al titolo farebbero un pulsante troppo alto */
    apri.classList.toggle('is-doppia', attivo && doppia);
    if (titolo) titolo.textContent = attivo ? TESTO_MODIFICA : TESTO_AGGIUNGI;
    if (riassunto) {
      if (attivo) {
        /* una incisione per riga: con The Bond "Amber: ..." e sotto
           "Walnut: ...", con un inalatore solo "Texto a grabar: ...".
           L'a capo lo rende il CSS (white-space: pre-line). */
        var nomi = nomiInalatori();
        var parti = [];
        if (doppia) {
          if (confermato.uno) parti.push((nomi[0] ? nomi[0] + ': ' : '') + confermato.uno);
          if (confermato.due) parti.push((nomi[1] ? nomi[1] + ': ' : '') + confermato.due);
        } else if (confermato.uno) {
          parti.push(ETICHETTA_SINGOLA ? ETICHETTA_SINGOLA + ': ' + confermato.uno : confermato.uno);
        }
        riassunto.textContent = parti.join('\n');
        riassunto.hidden = false;
      } else {
        riassunto.textContent = '';
        riassunto.hidden = true;
      }
    }
    if (togli) togli.hidden = !attivo;
  }

  function apriPannello(stato) {
    pannello.classList.toggle('is-aperto', stato);
    apri.setAttribute('aria-expanded', stato ? 'true' : 'false');
    if (stato) {
      mostraCampoDue();
      aggiornaStatoPulsanti();
      if (input1) { try { input1.focus({ preventScroll: true }); } catch (e) { input1.focus(); } }
    }
  }

  /* --------------------------------------------------------------- */

  apri.addEventListener('click', function () {
    apriPannello(!pannello.classList.contains('is-aperto'));
  });

  [[input1, conteggio1], [input2, conteggio2]].forEach(function (coppia) {
    var inp = coppia[0], span = coppia[1];
    if (!inp) return;
    inp.addEventListener('input', function () {
      var pulito = ripulisci(inp.value);
      if (pulito !== inp.value) {
        var pos = inp.selectionStart;
        inp.value = pulito;
        try { inp.setSelectionRange(pos, pos); } catch (e) {}
      }
      aggiornaConteggio(inp, span);
      aggiornaStatoPulsanti();
    });
  });

  /* --------------------------------------------------------------- */
  /* Dopo la conferma il cliente va accompagnato allo step successivo:
     lo step 2 si apre da solo e la pagina ci scorre sopra.             */

  /* quanto e alta la barra in cima che resta fissa mentre si scorre:
     senza questo conto lo step finirebbe nascosto sotto l'header */
  function altezzaBarraFissa() {
    var massimo = 0;
    var candidati = document.querySelectorAll('header, .section-header, sticky-header, .announcement-bar');
    for (var i = 0; i < candidati.length; i++) {
      var posizione = getComputedStyle(candidati[i]).position;
      if (posizione === 'fixed' || posizione === 'sticky') {
        var h = candidati[i].getBoundingClientRect().height;
        if (h > massimo) massimo = h;
      }
    }
    return massimo;
  }

  function vaiAlloStepDue() {
    var step = document.querySelector('.custom-journey-pack .step.step-2');
    if (!step) return;
    var contenuto = step.querySelector('.step-content');
    var titolo = step.querySelector('h2.step-title');
    /* il titolo fa da interruttore: cliccarlo quando e gia aperto lo
       richiuderebbe, quindi si tocca solo se serve */
    if (titolo && contenuto && contenuto.getAttribute('aria-expanded') !== 'true') {
      titolo.click();
    }
    /* un attimo di respiro: lo step si apre e la pagina si allunga,
       la posizione giusta si sa solo dopo */
    setTimeout(function () {
      var destinazione = step.getBoundingClientRect().top + window.pageYOffset - altezzaBarraFissa() - 12;
      try {
        window.scrollTo({ top: Math.max(0, destinazione), behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, Math.max(0, destinazione));
      }
    }, 80);
  }

  if (conferma) {
    conferma.addEventListener('click', function () {
      confermato.uno = ripulisci(input1 ? input1.value : '').trim();
      confermato.due = serveDoppia() ? ripulisci(input2 ? input2.value : '').trim() : '';
      aggiornaPulsante();
      apriPannello(false);
      vaiAlloStepDue();
    });
  }

  if (togli) {
    togli.addEventListener('click', function () {
      confermato.uno = '';
      confermato.due = '';
      if (input1) { input1.value = ''; aggiornaConteggio(input1, conteggio1); }
      if (input2) { input2.value = ''; aggiornaConteggio(input2, conteggio2); }
      aggiornaStatoPulsanti();
      aggiornaPulsante();
      apriPannello(false);
    });
  }

  /* se il cliente cambia inalatore, il numero di incisioni puo cambiare */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('#custom-product .step_one_cls')) return;
    setTimeout(function () {
      mostraCampoDue();
      if (!serveDoppia() && confermato.due) { confermato.due = ''; aggiornaPulsante(); }
      aggiornaStatoPulsanti();
      aggiornaRichiamo();
    }, 60);
  }, true);

  /* --------------------------------------------------------------- */
  /* Aggancio al carrello: lo chiama la sezione dopo aver messo
     l'inalatore nella lista degli articoli.                          */
  window.abIncisione = {
    testi: function () {
      return [confermato.uno, confermato.due].filter(Boolean);
    },

    applicaAlCarrello: function (articoli, proprietaDispositivo, elementoDispositivo) {
      var testi = window.abIncisione.testi();
      if (!testi.length) return;

      /* letto al momento, non all'avvio: cosi nell'editor del tema il
         cambio di impostazione si vede subito. Valori: 'inalatore'
         (predefinito), 'prodotto', 'entrambi'. */
      var DOVE_TESTO = radice.dataset.doveTesto || 'inalatore';

      var doppia = serveDoppia();
      var nomeDispositivo = '';
      if (elementoDispositivo && elementoDispositivo.dataset && elementoDispositivo.dataset.name) {
        nomeDispositivo = String(elementoDispositivo.dataset.name).trim();
      }

      /* Le chiavi che vedra' il magazzino. Con The Bond dicono a quale
         dei due inalatori appartiene ogni testo, non "1" e "2". */
      var k = doppia ? [etichettaPer(0), etichettaPer(1)] : [ETICHETTA_SINGOLA];

      function scrivi(dove) {
        dove[k[0]] = testi[0];
        if (doppia && testi.length > 1) dove[k[1]] = testi[1];
      }

      /* 1) il testo attaccato all'inalatore da incidere */
      if (proprietaDispositivo && DOVE_TESTO !== 'prodotto') {
        scrivi(proprietaDispositivo);
      }

      /* 2) la riga che il magazzino non puo' non vedere. Anche senza
            testo sopra resta il segnale: se c'e questo prodotto, ci sono
            incisioni da fare, e la quantita dice quante. */
      if (VARIANTE_PRODOTTO && articoli && articoli.push) {
        var prop = {};
        if (DOVE_TESTO !== 'inalatore') {
          scrivi(prop);
          /* Il riferimento serve solo con due inalatori: con uno solo il
             colore e gia sulla riga del kit, ripeterlo e rumore. */
          if (doppia && nomeDispositivo) prop[ETICHETTA_RIFERITO] = nomeDispositivo;
        }
        articoli.push({
          id: Number(VARIANTE_PRODOTTO),
          quantity: testi.length,
          properties: prop
        });
      }
    }
  };

  /* stato iniziale */
  mostraCampoDue();
  aggiornaConteggio(input1, conteggio1);
  aggiornaConteggio(input2, conteggio2);
  aggiornaStatoPulsanti();
})();
